import {
  formatPythonCode,
  formatJavaCode,
  formatCCode,
} from "./languageFormatters";
import { formatWithPrettier } from "./formatterRouter";

/**
 * Register all language formatters with Monaco Editor
 * @param {object} monaco - Monaco Editor instance
 */
export const registerLanguageFormatters = (monaco) => {
  // Register Python formatter (improved autopep8-style)
  monaco.languages.registerDocumentFormattingEditProvider("python", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatPythonCode(model.getValue());
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register JavaScript formatter
  monaco.languages.registerDocumentFormattingEditProvider("javascript", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "javascript");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register TypeScript formatter
  monaco.languages.registerDocumentFormattingEditProvider("typescript", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "typescript");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register Java formatter (improved basic indentation)
  monaco.languages.registerDocumentFormattingEditProvider("java", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatJavaCode(model.getValue());
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register C formatter (improved basic indentation)
  monaco.languages.registerDocumentFormattingEditProvider("c", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatCCode(model.getValue());
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register C++ formatter (improved basic indentation)
  monaco.languages.registerDocumentFormattingEditProvider("cpp", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatCCode(model.getValue());
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register C# formatter
  monaco.languages.registerDocumentFormattingEditProvider("csharp", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "csharp");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register Go formatter
  monaco.languages.registerDocumentFormattingEditProvider("go", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "go");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register Rust formatter
  monaco.languages.registerDocumentFormattingEditProvider("rust", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "rust");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register PHP formatter
  monaco.languages.registerDocumentFormattingEditProvider("php", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "php");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register Ruby formatter
  monaco.languages.registerDocumentFormattingEditProvider("ruby", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "ruby");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register Swift formatter
  monaco.languages.registerDocumentFormattingEditProvider("swift", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "swift");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register Kotlin formatter
  monaco.languages.registerDocumentFormattingEditProvider("kotlin", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "kotlin");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register Scala formatter
  monaco.languages.registerDocumentFormattingEditProvider("scala", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "scala");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register SQL formatter
  monaco.languages.registerDocumentFormattingEditProvider("sql", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "sql");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register F# formatter
  monaco.languages.registerDocumentFormattingEditProvider("fsharp", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "fsharp");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register Groovy formatter
  monaco.languages.registerDocumentFormattingEditProvider("groovy", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "groovy");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register Dart formatter
  monaco.languages.registerDocumentFormattingEditProvider("dart", {
    provideDocumentFormattingEdits: (model, options, token) => {
      const formattedCode = formatWithPrettier(model.getValue(), "dart");
      return [
        {
          range: model.getFullModelRange(),
          text: formattedCode,
        },
      ];
    },
  });

  // Register formatters for other languages with basic indentation
  const languagesWithBasicFormatting = [
    "r",
    "lua",
    "perl",
    "shell",
    "haskell",
    "ocaml",
    "clojure",
    "elixir",
    "erlang",
    "objective-c",
    "vb",
    "pascal",
    "fortran",
    "cobol",
    "d",
    "commonlisp",
    "prolog",
    "octave",
    "basic",
  ];

  languagesWithBasicFormatting.forEach((lang) => {
    monaco.languages.registerDocumentFormattingEditProvider(lang, {
      provideDocumentFormattingEdits: (model, options, token) => {
        const formattedCode = formatWithPrettier(model.getValue(), lang);
        return [
          {
            range: model.getFullModelRange(),
            text: formattedCode,
          },
        ];
      },
    });
  });
};
